import axios from "axios";

/**
 * Auth tokens live in an httpOnly cookie set by the backend.
 * `withCredentials: true` makes axios send/receive cookies on every request.
 *
 * We ALWAYS use a relative `/api` path so requests stay same-origin on whatever
 * domain the frontend is served from (afripantry.co.uk, grocery-vendors-live.emergent.host,
 * or the preview host). The Emergent ingress proxies `/api/*` on the frontend host
 * to the backend pod — so a call like `axios.get('/products')` hits
 * `https://<current-host>/api/products` and never crosses origins.
 *
 * Same-origin is critical for cookie auth: credentialed cross-origin requests require
 * `Access-Control-Allow-Origin: <origin>` (not `*`), which the Emergent edge sometimes
 * overrides to `*`, breaking credentialed requests.
 */
export const API = "/api";

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default api;
